interface IStatusResponce {
  status: string
}

interface ISearchResponse<T> {
  items: T[]
  length: number
}

type TStatusCallbak = (response: IStatusResponce) => void
// type TStatusCallbak = (response: IStatusResponce) => void
type TOneItemCallback<T> = (item: T) => void
type TArrayItemsCallback<T> = (items: Array<T>) => void
type TSearchCallback<T> = (response: ISearchResponse<T>) => void

function formURL(url: string): URL {
  if (url[0] !== '/') return new URL(window.location.origin + '/' + url)
  return new URL(window.location.origin + url)
}

const reqGet = (
  url: string,
  callback: (response: any) => void,
  onForbidden?: () => void,
  onError?: () => void
) => {
  // const from = document.location.pathname + document.location.search

  let is_call_callback = true
  let url_ = formURL(url).toString()

  fetch(url_, { method: 'GET' })
    .then((response) => {
      if (!response.ok) {
        if (response.statusText === 'UNAUTHORIZED' || response.status === 401) {
          // document.location.replace('#/login?logout=True')
          // document.location.replace('/after_login=' + from)
          document.location.replace('/#/logout')

          is_call_callback = false
        } else if (response.statusText === 'Forbidden' || response.status === 403) {
          if (onForbidden) {
            onForbidden()
          }
          is_call_callback = false
        } else {
          throw Error(response.statusText)
        }
      }
      return response.json()
    })
    .then((data) => {
      if (is_call_callback) callback(data)
    })
    .catch((e) => {
      console.log('No server response. ' + e + '\n', 'callbak: ', callback)
      if (onError) {
        onError()
      } else {
        // document.location.replace('/error?from=' + from)
      }
    })
}

const reqPost = (
  url: string,
  data: object,
  callback: (response: any) => void,
  onForbidden?: () => void,
  onError?: () => void
) => {
  // const from = document.location.pathname + document.location.search

  let is_call_callback = true
  let url_ = formURL(url).toString()

  fetch(url_, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (!response.ok) {
        if (response.statusText === 'UNAUTHORIZED' || response.status === 401) {
          // document.location.replace('/after_login=' + from)
          // document.location.replace('#/login?logout=True')
          document.location.replace('/#/logout')

          is_call_callback = false
        } else if (response.statusText === 'Forbidden' || response.status === 403) {
          if (onForbidden) {
            onForbidden()
          }
          is_call_callback = false
        } else {
          throw Error(response.statusText)
        }
      }
      return response.json()
    })
    .then((data) => {
      if (is_call_callback) callback(data)
    })
    .catch((e) => {
      console.log('No server response. ' + e)
      if (onError) {
        onError()
      } else {
        // document.location.replace('/error?from=' + from)
      }
    })
}

export { reqGet, reqPost }

export type {
  IStatusResponce,
  TStatusCallbak,
  TArrayItemsCallback,
  TOneItemCallback,
  TSearchCallback,
}
